import { CompanyPromotionDateOperator } from "@/generated/company-search";

export const OPERATOR_LABELS: Record<CompanyPromotionDateOperator, string> = {
  [CompanyPromotionDateOperator.GREATER_THAN]: "Greater than",
  [CompanyPromotionDateOperator.EQUAL_TO]: "Equal to",
  [CompanyPromotionDateOperator.LESS_THAN]: "Less than",
};
